export function appendHashConfig(url: string, config: any) {
  const hashPart = encodeURIComponent(JSON.stringify(config));
  return `${url}#${hashPart}`;
}

export function getHashConfig<ConfigType>(): ConfigType {
  const url = new URL(window.location.href);
  const hashPart = url.hash.substring(1);
  return JSON.parse(decodeURIComponent(hashPart));
}
